export default class GmoAskError extends Error {
  constructor(name, message, data, status, ...params) {
    super(...params);

    /* istanbul ignore next nodeのバージョン的に常にcaptureStackTraceが存在するため */
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GmoAskError);
    }

    this.name = name;
    this.message = message;
    this.data = data;
    this.status = status;
  }
}
